import React, {useContext} from 'react';
import {Navigate, Routes, Route} from 'react-router-dom'
import {authRoutes} from "../routes";
import {publicRoutes} from '../routes';
import {Context} from "../index";
import {observer} from "mobx-react-lite";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import {ADMIN_ROUTE} from "../utils/const";

const AppRouter = observer(() => {
    const {user} = useContext(Context);

    return (
        <Routes>
            {authRoutes.map(({path, Component}) =>
                <Route
                    key={path}
                    path={path}
                    element={user.isAuth ? Component : <Navigate to={ADMIN_ROUTE} replace/>}
                    exact
                />
            )}
            {publicRoutes.map(({path, Component}) =>
                <Route key={path} path={path} element={Component} exact/>
            )}
            <Route path='*' element={<ErrorPage/>}/>
        </Routes>
    );
});

export default AppRouter;
